/* 
Allows the connected wallet to stake (as a new delegator) to the current Orchestrator
*/
import { Stack, Text, Group } from "@mantine/core";
import { useBondingManager } from "../../../hooks/WithSmartContracts";
import { useState } from "react";
import { ethers } from "ethers";
import TextToNumberInput from "../components/TextToNumberInput";
import SmartContractAction from "../components/SmartContractAction";
import EthAddress from "../../EthAddress/EthAddress";

export default function NewStake(props) {
  const [isPending, setIsPending] = useState(false);
  const [thisTxn, setTxn] = useState("");
  const [thisErrMsg, setErrMsg] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const bondingManager = useBondingManager();

  const bondLPT = async () => {
    try {
      const { ethereum } = window;
      if (ethereum) {
        const thisValue = ethers.utils.parseEther(props.inputValue.toString());
        setIsPending(true);
        let hints = null;
        if (ethers.BigNumber.from(thisValue).gt(ethers.BigNumber.from(props.allowance))) {
          setErrMsg(
            "LPT token not approved for Livepeer's BondingManager smart contract"
          );
          props.setErr(true);
          return;
        }
        if (props.getHints) {
          hints = props.getHints(thisValue, "", props.orchestratorAddr);
        }
        console.log("Calculated hints:");
        console.log(hints);
        if (hints) {
          const txn = await bondingManager.bondWithHint(
            thisValue,
            props.orchestratorAddr,
            hints.oldDelegateNewPosPrev,
            hints.oldDelegateNewPosNext,
            hints.newDelegateNewPosPrev,
            hints.newDelegateNewPosNext
          );
          setTxn(txn.hash);
          await txn.wait();
        } else {
          const txn = await bondingManager.bond(thisValue, props.orchestratorAddr);
          setTxn(txn.hash);
          await txn.wait();
        }
        props.refreshWallet();
        setIsFinished(true);
      }
    } catch (error) {
      if (error.reason) {
        setErrMsg(error.reason);
      }
      props.setErr(true);
      setIsPending(false);
      setTxn(false);
      setIsFinished(false);
    }
  };

  return (
    <Stack spacing={24}>
      <Group position="center" spacing={24}>
        <EthAddress
          address={props.orchestratorAddr}
          cachedENS={props.cachedENS}
          preamble={
            "Stake to "
          }
        />
      </Group>
      <TextToNumberInput
        inputValue={props.inputValue}
        setInput={props.setInput}
        min={0}
        max={props.balance / ethers.constants.WeiPerEther}
        placeholder={"LPT"}
        description={
          (props.balance / ethers.constants.WeiPerEther).toFixed(2) +
          " LPT is currently available in your wallet"
        }
        label={"Stake"}
      />
      <SmartContractAction
        isPending={isPending}
        txn={thisTxn}
        thisErrMsg={thisErrMsg}
        isFinished={isFinished}
        action={bondLPT}
        actionMessage={"Stake your LPT"}
        finishedMessage={"Successfully staked!"}
        pendingMessage={"Delegating Stake..."}
      />
      {thisErrMsg != "" ? (
        <Text size="xl" fw={700}>
          The previous transaction failed with reason `{thisErrMsg}`
        </Text>
      ) : null}
    </Stack>
  );
}
